import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_MEMBERS = "members";
const BASE_URL = "/api/members";

const MemberQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const MEMBER_EMPTY = {
    nummer: "",
    provincie: "",
    sectorNr: "",
    sector: "",
    clubNr: "",
    clubNaam: "",
    lidNr: "",
    naam: "",
    voornaam: "",
    rijksRegisterNummer: "",
    adres1: "",
    huisNr: "",
    busNr: "",
    postCode: "",
    gemeente: "",
    nationaliteit: "",
    landCode: "",
    geboorteDatum: "",
    geslacht: "",
    categorie: "",
    telefoon: "",
    email: "",
    gsm: "",
    votasId: "",
    secretaris: "",
    voorzitter: "",
    scheidsrechter: "",
    actief: "",
    initiator: "",
    instructeurB: "",
    trainerB: "",
    trainerA: "",
    opmerking: "",

};

export function useMembers() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_MEMBERS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...MemberQueryConfig
    });
    return {...result, members: result.data};
}

export function useMembersDetailed() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_MEMBERS],
        queryFn: async () => await fetchGET(BASE_URL + '/detailed'),
        //onError: e => setError(e),
        ...MemberQueryConfig
    });
    return {...result, membersDetailed: result.data};
}


export function useMember(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_MEMBERS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...MemberQueryConfig
    });
    return {...result, member: result.data};
}

export function useMemberMutations() {
    async function createFunction(member) {
        if (!member) return;
        return await fetchPOST(BASE_URL, member, false);
    }

    async function editFunction(member) {
        if (!member) return;
        return await fetchPUT(`${BASE_URL}/${member.id}`, member);
    }

    async function editAddNewFiles(member) {
        if (!member) return;
        return await fetchPUT(`${BASE_URL}/${member.id}/files`, member.filesIds);
    }

    async function deleteFunction(member) {
        return await fetchDELETE(`${BASE_URL}/${member.id}`)
    }

    return {
        createMember: useMyMutation(createFunction, REACT_QUERY_ID_MEMBERS, member => `Member ${member.title} created`),
        editMember: useMyMutation(editFunction, REACT_QUERY_ID_MEMBERS, member => `Member ${member.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_MEMBERS, member => `Member ${member.title} modified`),
        deleteMember: useMyMutation(deleteFunction, REACT_QUERY_ID_MEMBERS, member => `Member ${member.title} deleted.`)
    };

}